export const SET_AIRPORT_DATA_BEGIN = 'SET_AIRPORT_DATA_BEGIN'
export const SET_AIRPORT_DATA_SUCCESS = 'SET_AIRPORT_DATA_SUCCESS'
export const SET_AIRPORT_DATA_ERROR = 'SET_AIRPORT_DATA_ERROR'
export const SET_SELECTED_RATE = 'SET_SELECTED_RATE'
export const SET_UPDATED_LOCATIONS = 'SET_UPDATED_LOCATIONS'
export const SET_SELECTED_LOCATION = 'SET_SELECTED_LOCATION'
export const SET_RESERVATION = 'SET_RESERVATION'
export const SET_RESERVATION_CONFIRMATION = 'SET_RESERVATION_CONFIRMATION'
export const SET_IS_SEARCHING = 'SET_IS_SEARCHING'
